export default __webpack_public_path__ + "static/media/setting.a63d86ef.svg";